import { RefObject, useEffect, useState, Dispatch, SetStateAction } from 'react';
import styles from '@features/cms/components/collections/VisualBlock/VisualStickyBar/VisualStickyBar.styles';
import ErrorBoundary from '@components/errors/ErrorBoundary';
import theme from '@styles/theme';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
import { ICmsDocument, IContentNavigation } from '@features/cms/typescript';
import VisualStickyBarLinks from '@features/cms/components/collections/VisualBlock/VisualStickyBarLinks/VisualStickyBarLinks';
import layoutUiState from '@features/layout/mobX/LayoutUiState';
type PropTypes = {
  subpages?: ICmsDocument[];
  visualBlockRef: RefObject<HTMLElement | null>;
  activeSlug: string;
  categorySlug: string;
  hasProducts?: boolean;
  setNewActiveSlug: Dispatch<SetStateAction<string>> | undefined;
  contentNavigation: IContentNavigation[] | null;
};
const VisualStickyBar = ({
  subpages = [],
  visualBlockRef,
  categorySlug,
  activeSlug,
  hasProducts = false,
  setNewActiveSlug,
  contentNavigation
}: PropTypes) => {
  const [isTriggered, setIsTriggered] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [layoutBarsTotalHeight, setLayoutBarsTotalHeight] = useState(0);
  let timer: NodeJS.Timeout;
  const {
    getLayoutFixedBarsHeight
  } = layoutUiState;
  const handleStickyBar = () => {
    if (visualBlockRef.current !== null) {
      const heightVh = visualBlockRef.current.offsetHeight;
      if (window.scrollY > heightVh) {
        setIsVisible(true);
        setIsTriggered(true);
      } else {
        setIsVisible(false);
      }
      setLayoutBarsTotalHeight(getLayoutFixedBarsHeight());
    } else {
      window.removeEventListener('scroll', handleStickyBar);
      clearTimeout(timer);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleStickyBar);
    timer = setInterval(() => handleStickyBar(), 100);
    return () => {
      window.removeEventListener('scroll', handleStickyBar);
      clearTimeout(timer);
    };
  }, [visualBlockRef]);
  const handleScrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  if (!isTriggered) {
    return <></>;
  }
  return <ErrorBoundary>
      <nav sx={styles.stickyNav(isVisible, layoutBarsTotalHeight)} data-cy="StickyBar" className="navigationStickyBar">
        <div sx={styles.stickyLeftBox}>
          <Button variant="iconOnly" onClick={handleScrollUp}>
            <Icon icon="NavigationBack" color={theme.rawColors.darkGrey700} size="24px" cy="ArrowBackBold" />
          </Button>
        </div>
        <VisualStickyBarLinks categorySlug={categorySlug} activeSlug={activeSlug} subpages={subpages} setNewActiveSlug={setNewActiveSlug} hasProducts={hasProducts} contentNavigation={contentNavigation} />
      </nav>
    </ErrorBoundary>;
};
export default VisualStickyBar;